import { useMemo } from 'react';

import { useQuery } from '@hooks/reactQuery';

import { getHistoryCheckAwtgRanManagedObjectsNames } from '@api/hitoryCheck';

import { TSelectOption } from '@interfaces/components/componentTypes';

import { EUserRoles } from '@enums/common';

import { refetchOptions } from '@constants/common';
import { HISTORY_CHECK_MO_NAMES } from '@constants/queryKeys';

interface IUseQueryHistoryCheckAwtgRanMoNamesParams {
	dumpHistoryId: string;
	dataModelPathId: string;
	isAwtgRanVendor?: boolean;
}

interface IUseQueryHistoryCheckAwtgRanMoNamesReturnValue {
	moNames: string[];
	moNamesOptions: TSelectOption<string>[];
	isLoadingMoNames: boolean;
}

export const useQueryHistoryCheckAwtgRanMoNames = ({
	dumpHistoryId,
	dataModelPathId,
	isAwtgRanVendor,
}: IUseQueryHistoryCheckAwtgRanMoNamesParams): IUseQueryHistoryCheckAwtgRanMoNamesReturnValue => {
	const {
		data: moNames = [],
		isLoading: isLoadingMoNames,
	} = useQuery<string[]>({
		queryFn: () => getHistoryCheckAwtgRanManagedObjectsNames(dumpHistoryId, dataModelPathId),
		queryKey: [HISTORY_CHECK_MO_NAMES, 'awtg-ran', dumpHistoryId, dataModelPathId],
		enabled: [!!(dumpHistoryId && dataModelPathId && isAwtgRanVendor)],
		allowedRoles: [
			EUserRoles.networkOperatorCmModuleEditor,
			EUserRoles.networkOperatorCmModuleViewer,
			EUserRoles.networkOperatorCmModuleAdmin,
		],
		...refetchOptions,
	});

	const moNamesOptions = useMemo(
		() => moNames.map(name => ({ label: name, value: name })),
		[moNames],
	);

	return {
		moNames,
		moNamesOptions,
		isLoadingMoNames,
	};
};
